export const AFFILIATE_FILTER_STORAGE_KEY = "casino.filters.affiliate";

export const persistAffiliateProviderFilter = (provider) => {
	if (!provider?.key) return [];

	const filter = {
		key: provider.key,
		value:
			window.TENANT === "betto"
				? provider.key
				: provider.value ??
					`${provider.key}${provider.count != null ? ` (${provider.count})` : ""}`,
		count: provider.count,
		section: "provider",
	};

	localStorage.removeItem("casino.filters.allGames");
	localStorage.setItem(AFFILIATE_FILTER_STORAGE_KEY, JSON.stringify([filter]));

	return [filter];
};

export const buildAffiliateProviderRoute = (provider, tabSlug = "casino") => {
	const key = provider?.key ?? provider;
	const count = provider?.count ?? 0;

	return `/provider?key=affiliate&name=${encodeURIComponent(key)}&count=${count}&tab=${tabSlug}`;
};

const decodeParam = (value) => {
	if (!value) return "";
	try {
		return decodeURIComponent(value);
	} catch {
		return value;
	}
};

export const getProviderFiltersFromUrl = (urlKey, name, count) => {
	if (urlKey !== "affiliate" || !name) return [];

	const decodedName = decodeParam(name);

	return [
		{
			key: decodedName,
			value: decodedName,
			count: count ? Number(count) : undefined,
			section: "provider",
		},
	];
};

export const clearBettoCasinoBrowseFilters = () => {
	localStorage.removeItem("casino.filters.affiliate");
	localStorage.removeItem("casino.filters.allGames");
};

export const buildAllGamesBrowseRoute = (tabSlug = "casino") =>
	`/provider?key=allGames&name=${encodeURIComponent("all games")}&tab=${tabSlug}`;

export const buildFavoritesBrowseRoute = (tabSlug = "casino", location) => {
	const pathname = location?.pathname ?? "";

	if (pathname === "/casino" || pathname.endsWith("/casino")) {
		return `/casino?page=${tabSlug}&browse=favorites`;
	}

	return `/provider?key=favorites&tab=${tabSlug}`;
};

export const getBettoCasinoNavKeyFromLocation = (location) => {
	const segment = location?.pathname?.split("/")[1] ?? "";
	const searchParams = new URLSearchParams(location?.search ?? "");

	if (segment === "casino") {
		const page = searchParams.get("page");
		return page === "livecasino" ? "live-casino" : "casino";
	}

	if (segment === "provider") {
		const tab = searchParams.get("tab");
		return tab === "livecasino" ? "live-casino" : "casino";
	}

	return null;
};

export const isBettoCasinoLobbyActive = (location, tab = "casino") => {
	if (location?.pathname !== "/casino") return false;

	const searchParams = new URLSearchParams(location?.search ?? "");

	if (searchParams.get("browse") === "favorites") return false;

	const page = searchParams.get("page")?.toLowerCase();
	const isLiveTab = tab === "livecasino" || tab === "LiveCasino";

	if (isLiveTab) {
		return page === "livecasino";
	}

	return !page || page === "casino";
};

export const isBettoHomeActive = (location) => {
	const pathname = location?.pathname ?? "";
	return pathname === "/" || pathname === "";
};

export const isBettoFavoritesActive = (location) => {
	const pathname = location?.pathname ?? "";
	const searchParams = new URLSearchParams(location?.search ?? "");

	if (searchParams.get("key") === "favorites") return true;
	if (searchParams.get("browse") === "favorites") return true;

	return pathname === "/casino-favorites" || pathname.endsWith("/casino-favorites");
};

export const isBettoProvidersActive = (location, navKey) => {
	if (getBettoCasinoNavKeyFromLocation(location) !== navKey) return false;

	const pathname = location?.pathname ?? "";
	const searchParams = new URLSearchParams(location?.search ?? "");

	if (pathname !== "/provider" && !pathname.endsWith("/provider")) return false;

	return searchParams.get("key") === "affiliate" && Boolean(searchParams.get("name"));
};

export const getLocationWithoutOpenProviders = (location) => {
	const searchParams = new URLSearchParams(location?.search ?? "");

	if (searchParams.get("openProviders") !== "true") return null;

	searchParams.delete("openProviders");
	const search = searchParams.toString();

	return {
		pathname: location.pathname,
		search: search ? `?${search}` : "",
	};
};
